import type { EndpointMap } from '../common';
import type { SkimRequest } from './skimmer.request';
import type { SkimResponse } from './skimmer.response';

/**
 * 헤더 검색(skimmer). 조회 범위: D3 = 전체, LP = 출자 펀드가 투자한 포트폴리오, 포트폴리오 = 자기 회사.
 * 필드도 역할에 따라 다르다(메모는 D3 만, LP 의 영업현황은 공개 리포트만).
 */
export const skimmerEndpoints = {
  skim: {
    method: 'GET',
    path: '/skimmer/:target',
    req: {} as SkimRequest,
    res: {} as SkimResponse,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS'],
  },
} as const satisfies EndpointMap;
